export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} van {2}',
    noResultsText: 'Geen overeenkomende resultaten gevonden',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'Rijen per pagina:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
  },
  dataFooter: {
    itemsPerPageText: 'Aantal per pagina:',
    itemsPerPageAll: 'Alles',
    nextPage: 'Volgende pagina',
    prevPage: 'Vorige pagina',
    firstPage: 'Eerste pagina',
    lastPage: 'Laatste pagina',
  },
  noDataText: 'Geen gegevens beschikbaar',
  carousel: {
    prev: 'Vorige visual',
    next: 'Volgende visueel',
  },
}
